<template>
	<el-select ref="select" :value="valueTitle" v-bind="$attrs" @clear="clearHandle" @visible-change="visibleChange">
		<el-option :value="valueTitle" :label="valueTitle">
			<el-tree
				id="tree-option"
				ref="selectTree"
				:accordion="accordion"
				:data="treeData"
				:props="props"
				lazy
				:load="loadChildren"
				:node-key="props.value"
				:default-expanded-keys="defaultExpandedKey"
				@node-click="handleNodeClick"
			></el-tree>
		</el-option>
	</el-select>
</template>
<script>
import { get, post } from "@/assets/common/request";
import { findComponentUpward } from "@/assets/common/component";
export default {
	name: "RoomSelectTreeWithUser",
	inheritAttrs: false,
	props: {
		// 项目ID
		projectId: {
			type: String,
			default: function() {
				return "";
			},
		},
		/* 初始值 */
		value: {
			default: () => {
				return "";
			},
		},
		/* 自动收起 */
		accordion: {
			type: Boolean,
			default: () => {
				return true;
			},
		},
	},
	data() {
		return {
			/* 配置项 */
			props: {
				value: "id", // ID字段名
				label: "label", // 显示名称
				children: "children", // 子级字段名
				isLeaf: (data, node) => {
					return (!node.data.children || node.data.children.length == 0 || node.level == 2) && node.level != 1;
				},
			},
			valueId: this.value, // 初始值
			valueTitle: "",
			defaultExpandedKey: [],
			treeData: [],
		};
	},
	mounted() {
		this.initHandle();
		this.loadTreeData();
	},
	methods: {
		loadTreeData() {
			get(this.$requestUrl.GET_FLOOR_TREE).then((data) => {
				this.treeData = this.find(data.data, this.projectId) || [];
			});
		},
		find(data, id) {
			let stack = Array.from(data);
			let finded = false;
			let current;
			while (!finded && (current = stack.pop())) {
				if (current.id == id) break;
				if (current.children) {
					stack = stack.concat(current.children);
				}
			}
			return current.children;
		},
		loadChildren(node, resolve) {
			if (node.data.children) {
				return resolve(node.data.children);
			}
			if (node.level == 1) {
				// 加载房间
				const floorId = node.data.id;
				const params = {
					floorId: floorId,
				};
				return post(this.$requestUrl.GET_FLOOR_LIST, params).then((data) => {
					if (data && data.data) {
						const treeData = data.data.map((item) => {
							return {
								id: item.customerId,
								label: `${item.roomName}|${item.customerName}`,
								data: item,
							};
						});
						return resolve(treeData);
					}
					return resolve([]);
				});
			}
			return resolve([]);
		},
		// 初始化值
		initHandle() {
			if (this.valueId) {
				this.valueTitle = this.$refs.selectTree.getNode(this.valueId).data[this.props.label]; // 初始化显示
				this.$refs.selectTree.setCurrentKey(this.valueId); // 设置默认选中
				this.defaultExpandedKey = [this.valueId]; // 设置默认展开
			}
			this.$nextTick(() => {
				let scrollWrap = document.querySelectorAll(".el-scrollbar .el-select-dropdown__wrap")[0];
				let scrollBar = document.querySelectorAll(".el-scrollbar .el-scrollbar__bar");
				scrollWrap.style.cssText = "margin: 0px; max-height: none; overflow: hidden;";
				scrollBar.forEach((ele) => (ele.style.width = 0));
			});
		},
		// 切换选项
		handleNodeClick(nodeData, node) {
			if (node.isLeaf) {
				this.valueTitle = nodeData[this.props.label];
				this.valueId = nodeData[this.props.value];
				this.$emit("input", this.valueId);
				this.defaultExpandedKey = [];
			}
		},
		visibleChange(visible) {
			if (!visible) {
				this.validate();
			}
		},
		validate() {
			const formItem = findComponentUpward(this, "ElFormItem");
			if (formItem) {
				const prop = formItem.prop;
				const form = formItem.form;
				if (prop && form) {
					form.validateField(prop);
				}
			}
		},
		// 清除选中
		clearHandle() {
			this.valueTitle = "";
			this.valueId = "";
			this.defaultExpandedKey = [];
			this.clearSelected();
			this.$emit("input", this.valueId);
		},
		/* 清空选中样式 */
		clearSelected() {
			let allNode = document.querySelectorAll("#tree-option .el-tree-node");
			allNode.forEach((element) => element.classList.remove("is-current"));
		},
	},
	watch: {
		value() {
			this.valueId = this.value;
			this.initHandle();
		},
	},
};
</script>

<style scoped>
.el-scrollbar .el-scrollbar__view .el-select-dropdown__item {
	height: auto;
	max-height: 274px;
	padding: 0;
	overflow: hidden;
	overflow-y: auto;
}
.el-select-dropdown__item.selected {
	font-weight: normal;
}
ul li >>> .el-tree .el-tree-node__content {
	height: auto;
	padding: 0 20px;
}
.el-tree-node__label {
	font-weight: normal;
}
.el-tree >>> .is-current .el-tree-node__label {
	color: #409eff;
	font-weight: 700;
}
.el-tree >>> .is-current .el-tree-node__children .el-tree-node__label {
	color: #606266;
	font-weight: normal;
}
</style>
